// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ArticleAction } from './ArticleAction';
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleActions = class ArticleActions extends Vue {
};
__decorate([
    Prop({ type: Array, required: true })
], ArticleActions.prototype, "actions", void 0);
ArticleActions = __decorate([
    Component({
        name: 'ArticleActions',
        components: { ArticleAction },
        template: `
    <ul class="article-actions list-inline mb-0">
      <li v-for="action in actions" :key="action.icon"
          class="article-actions__item list-inline-item"
          :class="{ 'd-none d-lg-inline-block': action.hideForMobile }">
        <ArticleAction v-bind="action" />
      </li>
    </ul>
  `
    })
], ArticleActions);
export { ArticleActions };
